export const HOME = { emergentLink: "home-emergent-link" };

export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerName: "register-name-input",
  registerSubmit: "register-submit-button",
  googleLogin: "google-login-button",
  logoutBtn: "logout-button",
  toggleRegister: "toggle-register-mode",
  toggleLogin: "toggle-login-mode",
};

export const NAV = {
  linkFeed: "nav-link-feed",
  linkDashboard: "nav-link-dashboard",
  linkCreate: "nav-link-create",
  linkPain: "nav-link-pain",
  linkAlt: "nav-link-alt",
  linkPlayground: "nav-link-playground",
  linkWallet: "nav-link-wallet",
  memberBadge: "membership-status-badge",
  subscribeBtn: "subscribe-stripe-button",
  profileTrigger: "profile-dropdown-trigger",
  profileMenu: "profile-dropdown-menu",
  profileItemWallet: "profile-menu-wallet",
  profileItemCai: "profile-menu-cai",
  profileItemMembership: "profile-menu-membership",
  profileItemSettings: "profile-menu-settings",
  profileItemLogout: "profile-menu-logout",
};

export const POST = {
  card: "post-card",
  emotionBadge: "post-emotion-badge",
  intensityBar: "post-intensity-bar",
  consistencyGrid: "post-consistency-pixel-grid",
  voteFor: "vote-for-button",
  voteAgainst: "vote-against-button",
  financierSlider: "financier-slider",
  financierSplitIndicator: "financier-split-indicator",
  financingBounceAlert: "financing-bounce-alert",
  financierPledge: "financier-pledge-button",
  altFinancierApply: "apply-alt-financier-btn",
  commentsToggle: "comments-toggle-button",
  commentInput: "comment-input",
  commentSubmit: "comment-submit-button",
  commentItem: "comment-item",
  commentVoteFor: "comment-vote-for-button",
  commentVoteAgainst: "comment-vote-against-button",
};

export const CREATE = {
  form: "create-post-form",
  content: "post-content-textarea",
  emotionSelect: "emotion-select-dropdown",
  publish: "publish-post-button",
  mediaInput: "post-media-input",
  visualizeBtn: "visualize-mentation-button",
  visualizeModel: "visualize-model-select",
  visualizePreview: "visualize-preview-image",
  visualizeClear: "visualize-clear-button",
};

export const FILTER = {
  bar: "emotion-filter-bar",
  melancholy: "filter-melancholy-btn",
  rage: "filter-rage-btn",
  serenity: "filter-serenity-btn",
  anxiety: "filter-anxiety-btn",
  euphoria: "filter-euphoria-btn",
  intensity: "intensity-range-slider",
  consistency: "consistency-range-slider",
  search: "feed-search-input",
  reset: "filter-reset-btn",
};

export const CAI = {
  container: "cai-dashboard-container",
  boileauCard: "steven-boileau-payout-card",
  painCard: "pain-suffering-pool-card",
  altCard: "alternate-financier-pool-card",
  rolloverIndicator: "unclaimed-rollover-indicator",
  waterfall: "cai-distribution-waterfall-chart",
};

export const PAIN = {
  openBtn: "pain-claim-open-btn",
  form: "pain-claim-form",
  amount: "claim-amount-input",
  reason: "claim-reason-textarea",
  submit: "claim-submit-button",
};

export const ALT = {
  widget: "alt-financier-widget",
  poolTotal: "pool-total-display",
  capBadge: "max-claim-limit-badge",
  openBtn: "apply-alt-financier-btn",
  form: "alt-financier-form",
  amount: "alt-amount-input",
  reason: "alt-reason-textarea",
  submit: "alt-submit-button",
};
